module.exports = __webpack_public_path__ + "startpage-746fed5a/app-store-badge-de-9fe34596af8c52c30cb26829e9d959fe.svg";